/* unplugin-vue-components disabled */import { render } from "./ColorGridMemoryRender.vue?vue&type=template&id=008267e4&scoped=true"
import script from "./ColorGridMemoryRender.vue?vue&type=script&lang=js"
export * from "./ColorGridMemoryRender.vue?vue&type=script&lang=js"

import "./ColorGridMemoryRender.vue?vue&type=style&index=0&id=008267e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008267e4"]])

export default __exports__